export default __webpack_public_path__ + "static/media/unqSvgLogo.789ee280.svg";